import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { faDash } from '@fortawesome/pro-solid-svg-icons';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { ProjectionScore } from '@sorare/core/src/components/scoring/ProjectionScore';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';

import { Cell } from 'components/searchPlayerTable/SearchTable/ui';

import type { ProjectionCell_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: ProjectionCell_anyPlayer;
  so5FixtureEvent: So5FixtureEvent;
};

export const ProjectionCell = ({ anyPlayer, so5FixtureEvent }: Props) => {
  const { up: laptopOrAbove } = useScreenSize('laptop');
  const projectedScore = (() => {
    switch (so5FixtureEvent) {
      case So5FixtureEvent.DAILY:
        return anyPlayer.nextDailyFixtureProjectedScore;

      case So5FixtureEvent.CLASSIC:
      default:
        return anyPlayer.nextClassicFixtureProjectedScore;
    }
  })();

  return (
    <Cell>
      {projectedScore === null ? (
        <FontAwesomeIcon icon={faDash} color="var(--c-nd-500)" />
      ) : (
        <ProjectionScore
          size={laptopOrAbove ? 4 : 3}
          projectedScore={projectedScore}
          so5FixtureEvent={so5FixtureEvent}
        />
      )}
    </Cell>
  );
};

ProjectionCell.fragments = {
  anyPlayer: gql`
    fragment ProjectionCell_anyPlayer on AnyPlayerInterface {
      slug
      nextDailyFixtureProjectedScore
      nextClassicFixtureProjectedScore
    }
  ` as TypedDocumentNode<ProjectionCell_anyPlayer>,
};
